<template>
  <head>
  </head>
  <title>eLogbook</title>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      isAssessor: false,
    };
  },
  mounted() {
    document.title = "eLogbook"; // Set the desired tab name
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} 
body {
  padding:0;
  margin:0;
}
.table td, .table th {
    vertical-align: middle !important;
}
.skinny-column {
  width: 6%; 
}

.wider-column {
  width: 40%; 
}

.logo {
  padding:0px;
  margin:0px;
}


input #logbookName {
    margin-bottom: 20px;
}

.logged-in-info {
  position: absolute;
  top: 56px;
  left: 120px;
  padding: 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.logged-in-label {
  position: absolute;
  top: 56px;
  left: 10px;
  padding: 10px;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
}

h1 {
  padding-top: 20px;
}


h2 {
  margin-left: 5%;
  text-align:left;
}

/* .custom-table {
  border-collapse: collapse;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 5%;
}

.custom-table th,
.custom-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
  
}

.custom-table th {
  background-color: rgba(77, 123, 161, 0.144); 
  font-size: 14px;
} */

.register button, .login button, .add button:hover {
  background-color: #1b78db;
  border-color: #002c5c;
  color: aliceblue;
}

.register button:hover,
.login button:hover,
.add button:hover {
  transform: scale(1.02); /* Increase size on hover */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add shadow on hover */
  border-color: #002c5c;
}

.register button,
.login button,
.add button {
  width: 200px;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 0px;
  border: 1px solid rgb(0, 96, 134);
  background: #1b78db;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

select.form-control {
  -webkit-appearance: menulist; /* For Safari/Chrome */
  -moz-appearance: menulist;    /* For Firefox */
  appearance: menulist;         /* Standard */
}

.current-time-container {
  position: absolute;
  top: 60px;
  right: 10px;
  display: flex;
  align-items: center;

}

.time-label {
  margin-right: 5px;
  font-weight: bold;
}

.current-time {
  font-size: 16px;
}

span .dropdown-icon {
  transform: rotate(0deg);
  transition: all 0.1s ease;
  &.dropdown {
    transform: rotate(180deg);
      }
    }


span {
  border: none !important;
  margin-top: 0px !important;
  font-size: 14px !important;
}

span:hover {
  color: black !important;
  cursor: auto !important;
}

.edit-button {
  background-color: #528b4d;
  color: #fff;
  border: 1px solid #006e12;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 14px;
  cursor: pointer;
}

.edit-button:hover {
  background-color: #125017;
  border-color: #0c3d07;
  color: #e7e7e7;
}

.edit-button:focus {
  outline: none;
}

.edit-button:active .btn-primary:active {
  background-color: #0056b3;
  border-color: #044081;
}
/* 
.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid black !important;
    border-top: 1px solid black;
} */

.error-message {
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  border: 1px solid #fa6f6f;
  margin-top: 20px;
  margin-bottom: 1300px;
  padding: 10px;
  border-radius: 5px;
  white-space: pre-line;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: red;
  font-size: 14px;
}

.btn-primary {
    border-color: #2552a7;
    margin-bottom: 20px;
}


#homeButton {
  background-color: #428d55;
  border-color: #008d21 !important;
  margin-bottom: 0px;
}

#homeButton:hover {
  background-color: #296536;
}

.modal-content {
  position: relative;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #dddddd !important;
  border-radius: 3px !important;
}

.Evaluation-modal-content {
  position: relative;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #dddddd;
}

.offline-box,
.sync-progress-box,
.sync-complete-box {
  width: 90%;
  max-width: 520px;
  padding: 8px 14px;
  font-size: 16px;
  border-radius: 5px;
  margin-bottom: 0;
  text-align: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.offline-box {
  background-color: rgb(250, 190, 190);
  color: rgb(194, 0, 0);
  border: 1px solid rgb(201, 141, 141);
}

.sync-progress-box {
  background: rgb(255, 216, 144);
  color: rgb(160, 85, 0);
  border: 1px solid rgb(231, 189, 111);
}

.sync-complete-box {
  background-color: #b0e6bd;
  color: rgb(0, 119, 16);
  border: 1px solid #82c492;
}

.success-box {
  width: 90%;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: #b0e6bd;
  color: rgb(0, 119, 16);
  font-size: 16px;
  border: 1px solid #82c492;
  border-radius: 5px;
  margin-bottom: 0;
  justify-content: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.pending-box {
  width: 90%;
  padding-top: 8px;
  padding-bottom: 8px;
  background: rgb(255, 216, 144);
  color: rgb(160, 85, 0);
  font-size: 16px;
  border: 1px solid rgb(231, 189, 111);
  border-radius: 5px;
  margin-bottom: 0;
  justify-content: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.sync-main-text {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
}

.small-sync-text {
  font-size: 13px;
  margin-top: 4px;
  opacity: 0.9;
}

.sync-progress-bar {
  width: 100%;
  max-width: 420px;
  height: 8px;
  background: rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  margin-top: 8px;
  overflow: hidden;
}

.sync-progress-fill {
  height: 100%;
  background: rgba(160, 85, 0, 0.9);
  border-radius: 999px;
  transition: width 0.3s ease;
}

.sync-complete-box .sync-progress-fill {
  background: rgba(0, 119, 16, 0.85);
}

.offline-box .sync-progress-fill {
  background: rgba(194, 0, 0, 0.75);
}

:disabled {
    cursor: not-allowed;
}

.window-close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: grey;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.window-close-icon:hover {
  color: rgb(87, 87, 87);
  cursor: pointer;
  transform: scale(1.02);
}

.modal-content {
  border: 1px solid #dddddd;
}

/* Modal Expand Animation */
.modal-expand-enter-active,
.modal-expand-leave-active {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.modal-expand-enter-from {
  transform: scale(0.9);
  opacity: 0;
}

.modal-expand-enter-to {
  transform: scale(1);
  opacity: 1;
}

.modal-expand-leave-from {
  transform: scale(1);
  opacity: 1;
}

.modal-expand-leave-to {
  transform: scale(0.9);
  opacity: 0;
}

.offline-box, .expired-box {
  width: 90%;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-bottom: 20px;
  background-color: rgb(250, 190, 190);
  color: rgb(194, 0, 0);
  font-size: 16px;
  border: 1px solid rgb(201, 141, 141);
  border-radius: 5px;
  margin-bottom: 0;
  justify-content: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.vgt-table {
  table-layout: fixed !important;
  width: 100%;
  font-size: 14px !important;
}

.vgt-wrap__footer {
    padding: 10px !important;
    border: 1px solid #707070bf !important;
    border-top: none !important;
    color: rgb(77, 77, 77) !important;
    background: linear-gradient(#e9eaec, #dddfe2) !important;
    margin-bottom: 20px;
}

.footer__navigation__page-info {
    font-size: 14px !important;
    color: rgb(77, 77, 77) !important;
}

.footer__row-count__label,
.footer__row-count__select {
    font-size: 14px !important;
    margin-top: 2px;
    color: rgb(77, 77, 77) !important;
}

table.vgt-table td {
    padding: 0.7em 0.7em 0.7em 0.7em !important;
    color: rgb(78, 78, 78) !important;
    border: 1px solid #707070bf !important;
    vertical-align: middle !important;
    font-weight: 500 !important;
    font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif !important;
}

table.vgt-table th {
    padding: 0.5em 0.5em 0.5em 0.5em !important;
    border: 1px solid #707070bf !important;
    color: rgb(77, 77, 77) !important;
    background: linear-gradient(#e9eaec, #dddfe2) !important;
}

table.vgt-table td {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

table.vgt-table tbody tr:nth-child(even) {
    background-color: rgba(240, 240, 240, 0.804);
}

table.vgt-table tbody tr.highlight-row td {
  background-color: rgba(218, 248, 252, 0.7) !important;
}

table.vgt-table tbody tr.enabled-task td {
  background-color: #c8f5c8 !important;
}

table.vgt-table tbody tr.partially-enabled-task td {
  background-color: #fff3cd !important;
}

.vgt-table .enabled-task td,
.vgt-table .enabled-task td * {
  background-color: #c8f5c8 !important;
}

.vgt-table .partially-enabled-task td,
.vgt-table .partially-enabled-task td * {
  background-color: #fff3cd !important;
}

.vgt-select {
  background-color: #fcfdff !important;
  border: 1px solid #707070 !important;
  padding: 5px 8px !important;
  font-size: 14px !important;
  color: #4d4d4d !important;
  cursor: pointer !important;
}

/* Style on hover */
.vgt-select:hover {
  background-color: #ffffff !important;
}

.vgt-id-column {
  width: 40px !important;
}

.vgt-foreign-id-column {
  width: 100px !important;
}

.vgt-ata-column {
  width: 90px !important;
}

.vgt-task-no-column {
  width: 90px !important;
}

.vgt-manob-column {
  width: 90px !important;
}

.vgt-P1-column {
  width: 70px !important;
}

.vgt-user-name-column {
  width: 200px !important;
}

.vgt-name-column {
  width: 300px !important;
}

.vgt-reference-column {
  width: 160px !important;
}

.vgt-description-column {
  width: auto !important;
}

.vgt-project-name-column {
  width: 500px !important;
}

.vgt-logbook-name-column {
  width: 400px !important;
}

.vgt-actions-column {
  width: 90px !important;
  text-align: center !important;
}

.vgt-actions-large-column {
  width: 120px !important;
  text-align: center !important;
}

.vgt-select-column {
  width: 40px !important;
  text-align: center !important;
}

table.vgt-table td.vgt-actions-column,
table.vgt-table td.vgt-actions-large-column {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.vgt-pending-column {
  width: 140px !important;
  text-align: center !important;
}

.vgt-catalog-column {
  width: 100px !important;
  text-align: center !important;
}


.vgt-first-name-column {
  width: 100px !important;
}

.vgt-last-name-column {
  width: 100px !important;
}

.vgt-email-column {
  width: 180px !important;
}

.vgt-logbook-column {
  width: 450px !important;
  font-size: 12px !important;
}

.vgt-uid-column {
  width: 100px !important;
}

.vgt-external-id-column {
  width: 140px !important;
}

.vgt-multi-id-column {
  width: 130px !important;
}

.vgt-pace-column {
  width: 140px !important;
}

.vgt-date-column {
  width: 100px !important;
}

.vgt-role-column {
  width: 150px !important;
}

.vgt-department-column {
  width: 100px !important;
}

.vgt-business-column {
  width: 110px !important;
}

.vgt-category-column {
  width: 60px !important;
}

.vgt-status-column {
  width: 80px !important;
  text-align: center !important;
}

.vgt-location-column {
  width: 130px !important;
}

.title-container {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-container {
  display: flex;
  flex-wrap: wrap; /* allow wrapping to next line */
  gap: 10px;       /* space between items */
  max-width: 700px; /* optional: limits row width so wrapping happens naturally */
  margin-right: 20px;
}

.filter-container input,
.filter-container select {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

/* Make each input take 32% width so 3 fit in a row */
.filter-container input:nth-child(-n+3) {
  flex: 1 1 calc(23.3% - 10px);
}

/* Remaining items go on next row */
.filter-container input:nth-child(n+4),
.filter-container select {
  flex: 1 1 calc(23.3% - 10px);
}


.clear-filter-button {
  flex: 1 1 calc(23.3% - 80px);
  width: 120px;
  margin-right: 35px;
  margin-left: 35px;
  margin-top: 2px;
  border-radius: 5px;
  background-color: #dee2e6;
  font-size: 14px;
  height: 30px;
  border: 2px solid black;
  line-height: 0px;
}

.clear-filter-button:hover {
  background-color: #cecece;
  cursor: pointer;
}

.password-rules { color: red; }

/* ===== RESPONSIVE TABLE STYLES ===== */

/* Large screens: 1200px – 1399px */
@media (max-width: 1399px) {
  .vgt-name-column           { width: 240px !important; }
  .vgt-project-name-column   { width: 380px !important; }
  .vgt-logbook-name-column   { width: 300px !important; }
  .vgt-logbook-column        { width: 340px !important; }
  .vgt-email-column          { width: 160px !important; }
  .vgt-reference-column      { width: 130px !important; }
}

/* Tablet/medium screens: 992px – 1199px */
@media (max-width: 1199px) {
  .vgt-table { font-size: 13px !important; }

  table.vgt-table td { padding: 0.5em !important; }
  table.vgt-table th { padding: 0.4em !important; }

  .vgt-id-column             { width: 44px  !important; }
  .vgt-foreign-id-column     { width: 85px  !important; }
  .vgt-ata-column            { width: 75px  !important; }
  .vgt-task-no-column        { width: 75px  !important; }
  .vgt-manob-column          { width: 75px  !important; }
  .vgt-P1-column             { width: 58px  !important; }
  .vgt-name-column           { width: 200px !important; }
  .vgt-reference-column      { width: 120px !important; }
  .vgt-project-name-column   { width: 280px !important; }
  .vgt-logbook-name-column   { width: 240px !important; }
  .vgt-logbook-column        { width: 270px !important; }
  .vgt-actions-column        { width: 75px  !important; }
  .vgt-actions-large-column  { width: 100px !important; }
  .vgt-pending-column        { width: 115px !important; }
  .vgt-catalog-column        { width: 82px  !important; }
  .vgt-first-name-column     { width: 88px  !important; }
  .vgt-last-name-column      { width: 88px  !important; }
  .vgt-email-column          { width: 148px !important; }
  .vgt-uid-column            { width: 82px  !important; }
  .vgt-external-id-column    { width: 115px !important; }
  .vgt-multi-id-column       { width: 105px !important; }
  .vgt-date-column           { width: 85px  !important; }
  .vgt-role-column           { width: 96px  !important; }
  .vgt-department-column     { width: 82px  !important; }
  .vgt-category-column       { width: 66px  !important; }
  .vgt-status-column         { width: 66px  !important; }
  .vgt-location-column       { width: 106px !important; }
}

/* Small screens: 768px – 991px */
@media (max-width: 991px) {
  .vgt-table { font-size: 12px !important; }

  table.vgt-table td { padding: 0.4em !important; }
  table.vgt-table th { padding: 0.35em !important; }

  .vgt-id-column             { width: 38px  !important; }
  .vgt-foreign-id-column     { width: 70px  !important; }
  .vgt-ata-column            { width: 60px  !important; }
  .vgt-task-no-column        { width: 60px  !important; }
  .vgt-manob-column          { width: 60px  !important; }
  .vgt-P1-column             { width: 48px  !important; }
  .vgt-name-column           { width: 160px !important; }
  .vgt-reference-column      { width: 96px  !important; }
  .vgt-project-name-column   { width: 210px !important; }
  .vgt-logbook-name-column   { width: 190px !important; }
  .vgt-logbook-column        { width: 210px !important; font-size: 11px !important; }
  .vgt-actions-column        { width: 62px  !important; }
  .vgt-actions-large-column  { width: 84px  !important; }
  .vgt-pending-column        { width: 95px  !important; }
  .vgt-catalog-column        { width: 68px  !important; }
  .vgt-first-name-column     { width: 74px  !important; }
  .vgt-last-name-column      { width: 74px  !important; }
  .vgt-email-column          { width: 128px !important; }
  .vgt-uid-column            { width: 68px  !important; }
  .vgt-external-id-column    { width: 96px  !important; }
  .vgt-multi-id-column       { width: 88px  !important; }
  .vgt-date-column           { width: 72px  !important; }
  .vgt-role-column           { width: 80px  !important; }
  .vgt-department-column     { width: 68px  !important; }
  .vgt-category-column       { width: 56px  !important; }
  .vgt-status-column         { width: 56px  !important; }
  .vgt-location-column       { width: 88px  !important; }

  /* Title + filters stack vertically */
  .title-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .filter-container {
    max-width: 100%;
    margin-right: 0;
  }
}

/* Mobile screens: < 768px */
@media (max-width: 767px) {
  .vgt-table { font-size: 11px !important; }

  table.vgt-table td { padding: 0.3em !important; }
  table.vgt-table th { padding: 0.3em !important; }

  .vgt-id-column             { width: 32px  !important; }
  .vgt-foreign-id-column     { width: 56px  !important; }
  .vgt-ata-column            { width: 50px  !important; }
  .vgt-task-no-column        { width: 50px  !important; }
  .vgt-manob-column          { width: 50px  !important; }
  .vgt-P1-column             { width: 40px  !important; }
  .vgt-name-column           { width: 120px !important; }
  .vgt-reference-column      { width: 76px  !important; }
  .vgt-project-name-column   { width: 160px !important; }
  .vgt-logbook-name-column   { width: 150px !important; }
  .vgt-logbook-column        { width: 160px !important; font-size: 10px !important; }
  .vgt-actions-column        { width: 52px  !important; }
  .vgt-actions-large-column  { width: 70px  !important; }
  .vgt-pending-column        { width: 80px  !important; }
  .vgt-catalog-column        { width: 56px  !important; }
  .vgt-first-name-column     { width: 62px  !important; }
  .vgt-last-name-column      { width: 62px  !important; }
  .vgt-email-column          { width: 108px !important; }
  .vgt-uid-column            { width: 56px  !important; }
  .vgt-external-id-column    { width: 80px  !important; }
  .vgt-multi-id-column       { width: 74px  !important; }
  .vgt-date-column           { width: 62px  !important; }
  .vgt-role-column           { width: 66px  !important; }
  .vgt-department-column     { width: 58px  !important; }
  .vgt-category-column       { width: 48px  !important; }
  .vgt-status-column         { width: 48px  !important; }
  .vgt-location-column       { width: 74px  !important; }

  .title-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-top: 10px;
  }

  .filter-container {
    max-width: 100%;
    margin-right: 0;
  }

  .filter-container input,
  .filter-container select {
    font-size: 14px;
  }

  .footer__navigation__page-info,
  .footer__row-count__label,
  .footer__row-count__select {
    font-size: 12px !important;
  }
}
</style>